import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeCurrency } from '../../utilities';
// import CurrencyExchange from '../../api/currencyExchange';

const SelectList = ({
  id,
  name,
  className,
  required,
  list,
  calculationsData,
  setCalculationsData,
}) => {
  const mockCurrencies = {
    base: 'MXN',
    rates: {
      ARS: 6.142629,
      BRL: 0.243262,
      BTC: 1.666033e-06,
      CLF: 0.001541,
      CLP: 42.521759,
      COP: 201.267925,
      GTQ: 0.392701,
      MXN: 1,
      PAB: 0.051168,
      PEN: 0.187938,
      PYG: 351.088485,
      USD: 0.051188,
      UYU: 2.04155,
      VEF: 10945612963.97131,
    },
  };
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [value, setValue] = useState(list?.length > 0 ? list[0] : {});

  useEffect(async () => {
    // const currencies = await CurrencyExchange.getCurrencies().quotes;
    // if (currencies?.quotes?.length < 1 || !currencies?.quotes) return;
    // const [selectedCurrency] = currencies.quotes.filter((currency) => currency.includes(value.currencyCode));

    const [selectedCurrency] = Object.keys(mockCurrencies.rates).filter((currency) => (
      currency.includes(value.currencyCode)));
    const currencyRate = mockCurrencies.rates[selectedCurrency];
    changeCurrency(currencyRate, selectedCurrency, setCalculationsData, calculationsData);
  }, [value]);

  return (
    <div role="none" onClick={() => setIsDisplayed(!isDisplayed)} className={className}>
      <button
        style={{ backgroundColor: 'transparent', color: '#ffff', border: 'none' }}
        type="button"
        name={name}
        id={id}
        required={required}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          key={value.currency}
          value={value.currency}
        >
          <img
            style={{ borderRadius: '3px', width: '30px', height: '15px' }}
            alt={value.country}
            src={value.image}
          />
          <p style={{ margin: '5px 0 5px 10px', fontSize: '10px' }}>{value.currencyCode}</p>
        </div>
      </button>
      {isDisplayed
        && (
          <div
            style={{
              position: 'absolute',
              top: '0',
              color: 'black',
              zIndex: '1',
              transform: 'translate(-15px, 55px)',
              backgroundColor: '#fafafa',
              borderRadius: '10px',
              padding: '5px 20px',
              boxShadow: '0px 0px 4px 1px #2d2e2e3b',
            }}
          >
            {/* <div className={className} value="" disabled>
              {placeholder || 'Cargando...'}
            </div> */}
            {list.length > 0 && list.map((item) => (
              <div
                role="none"
                onClick={() => setValue(item)}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                key={item.currency}
                value={item.currency}
              >
                <img
                  style={{ borderRadius: '3px', width: '30px', height: '15px' }}
                  alt={item.country}
                  src={item.image}
                />
                <p style={{ margin: '5px 0 5px 10px', fontSize: '10px' }}>{item.currencyCode}</p>
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

SelectList.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.shape({
    currency: PropTypes.string,
    country: PropTypes.string,
    image: PropTypes.string,
    currencyCode: PropTypes.string,
  })).isRequired,
  calculationsData: PropTypes.shape({
    currentCurrencyRate: PropTypes.number,
  }),
  setCalculationsData: PropTypes.func,
};

SelectList.defaultProps = {
  id: 'standard-select',
  name: '',
  className: 'select',
  required: false,
  calculationsData: {},
  setCalculationsData: () => {},
};

const mapStateToProps = (state) => (
  {
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectList);
